import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PlacesService {

  constructor(
    private api: ApiService,
  ) { }

  get(search_term) {
    return this.api.post('people/places', search_term).pipe(map(result => result.data.map(each => each.description)));
  }
}